export const FlaskIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22">
		<path
			fill="currentColor"
			d="M2.062 22c-.309 0-.622-.07-.9-.22a1.972 1.972 0 0 1-.995-1.15A1.999 1.999 0 0 1 .28 19.1L5.349 8.98c.069-.14.105-.3.105-.45V2h-.5c-.552 0-1-.45-1-1s.448-1 1-1h7a1.001 1.001 0 0 1 0 2h-.5v6.53c0 .15.036.31.105.45l5.069 10.12c.14.28.214.6.212.91a1.967 1.967 0 0 1-.596 1.41c-.38.38-.897.58-1.418.58H2.062ZM7.454 8.53V2h2v6.53c0 .46.109.92.317 1.34L11.835 14H5.07l2.067-4.13c.208-.41.317-.88.317-1.34ZM4.069 16l-2.001 4h12.766l-1.999-4H4.069Z"
		/>
	</svg>
);
